/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from "react";
import Footer from "./Footer";
import LanguageCard from "./LanguageCard";
import NavigationBar from "./NavigationBar";
import CampaignBanner from "./CampaignBanner";
import { useDispatch } from "react-redux";
import { getSetting } from "../../actions/admin/settings";
import { useLocation } from "react-router-dom";

const FrontLayout = (props) => {
  const dispatch = useDispatch();
  const pathname = useLocation();
  const hideFooterPaths = ["/book", "/checkout", "/login"];
  const isShowFooter = !hideFooterPaths.includes(pathname.pathname);

  // Always refetch, rather than `if (!setting)`. The reducer hydrates `setting`
  // from the `jsonstring` localStorage cache, so the old guard meant a returning
  // visitor never asked the server again -- an admin changing carttimeout (or
  // buffertime, editBooking, travelAreaPrice) never reached them. The cached copy
  // still renders first, so there is no flash while this resolves.
  useEffect(() => {
    dispatch(getSetting());
  }, []);
  const isCampaignPage = /^(\/[a-z]{2})?\/?$/.test(pathname.pathname) || /^(\/[a-z]{2})?\/book$/.test(pathname.pathname);
  const isBookPage = /^(\/[a-z]{2})?\/book$/.test(pathname.pathname)
  const showCampaignBanner = process.env.REACT_APP_SUMMER_CAMPAIGN === "true" && isCampaignPage;
  return (
    <Fragment>
      <NavigationBar />
      {showCampaignBanner && <CampaignBanner />}
      <div className={`${!showCampaignBanner ? "tw:!mt-22" : ""}`}>
        {props.children}
      </div>
      <div className="tw:lg:!hidden tw:sm:!block tw:fixed tw:right-[10px] tw:bottom-[10px] tw:!z-50">
        <LanguageCard dropUp />
      </div>
      {isShowFooter && (
        <div className={`${isBookPage ? "tw:mt-35 tw:md:mt-0" : ""}`}>
          <Footer />
        </div>
      )}
    </Fragment>
  );
};

export default FrontLayout;
